import { Fn as e } from "@cometjs/core";

function n(n, t) {
  if (!n.__typename) throw new Error("The given object doesn't have __typename");
  return e.range(t[n.__typename], n);
}

var t = n,
    r = n;

function o(n, t) {
  if (!n.__typename) throw new Error("The given object doesn't have __typename");
  return e.range(t[n.__typename] || t._, n);
}

var _ = o,
    a = o;
export { n as mapAbstractType, o as mapAbstractTypeWithDefault, r as mapInterface, a as mapInterfaceWithDefault, t as mapUnion, _ as mapUnionWithDefault };